(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lynove-quantity-total')) {
    customElements.define('lynove-quantity-total', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.form = this.closest('form');
        this.formatter = new Intl.NumberFormat('es-CL', {style: 'currency', currency: 'CLP', maximumFractionDigits: 0});
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent);
        this.refresh = () => this.updateTotal();
        ['input', 'change'].forEach(eventName => this.form.addEventListener(eventName, this.refresh, {signal: this.controller.signal}));
        this.updateTotal();
      }
      disconnectedCallback() { this.controller?.abort(); }
      updateTotal() {
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        const variantInput = this.form.querySelector('input[name="id"]');
        const unitPrice = this.prices[variantInput?.value || this.dataset.initialVariant];
        if (!Number.isFinite(unitPrice)) { this.hidden = true; return; }
        this.hidden = false;
        const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);
        const original = unitPrice * quantity;
        const saving = Math.min(original, quantity >= 5 ? quantity * 400000 : quantity === 4 ? 1800000 : quantity === 3 ? 1200000 : quantity === 2 ? 600000 : 0);
        const money = amount => this.formatter.format(amount / 100);
        this.querySelector('[data-total]').textContent = money(original - saving);
        this.querySelector('[data-original]').textContent = money(original);
        this.querySelector('[data-saving]').textContent = 'Ahorras ' + money(saving);
        this.querySelector('[data-discount]').hidden = saving === 0;
        this.querySelector('[data-detail]').textContent = quantity + (quantity === 1 ? ' unidad' : ' unidades') + ' · Grupo ' + this.dataset.group;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
